import React, { Component } from "react";
import { FormControl, FormControlLabel, Typography, RadioGroup, Radio, Button } from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import CustomDialog from "../../../layout/CustomDialog";
import LabeledTextField from "../../../layout/LabeledTextField";
import Popup from "../../../../assets/images/popup.png";

// Original optional props:
// open
// onClose

// Extended optional props:
// handleResults - force the result.

class IsMutavAllowedDialog extends Component {
  state = {
    propertyGotBefore2013: true,
    isSellerUsedMasMutavBefore: false,
    sellerUsedMasMutavAmount: 1,
    sellerSellAnotherPropertyWithPtor: false,
    isBuyetRelatedToSeller: false,
    isSoldAsHalukatIzavon: false,
    isChecked: false,
    isZakai: false
  };

  render() {
    const isUsageCountEnabled = this.state.isSellerUsedMasMutavBefore;
    const isOtherSaleQuestionEnabled = this.state.isSellerUsedMasMutavBefore && this.state.sellerUsedMasMutavAmount !== 2;
    const isRelatedBuyerQuestionEnabled =
      !this.state.sellerSellAnotherPropertyWithPtor && this.state.sellerUsedMasMutavAmount !== 2;
    const isEstateQuestionEnabled = this.state.isBuyetRelatedToSeller && this.state.sellerUsedMasMutavAmount !== 2;

    let resultStatusClass = "is-pending";
    let resultText = "החלטת המערכת:";
    if (this.state.isChecked) {
      resultStatusClass = this.state.isZakai ? "is-eligible" : "is-not-eligible";
      resultText = this.state.isZakai ? "החלטת המערכת: זכאי" : "החלטת המערכת: לא זכאי";
    }

    return (
      <CustomDialog
        label="בדיקת זכאות מס מוטב סעיף 48א(ב2)"
        open={this.props.open}
        onClose={this.props.onClose}
        maxWidth="lg"
        paperClassName="deal-calc-dialog"
        isContentDivided={false}
      >
        <div className="deal-calc-dialog-layout">
          <div className="deal-calc-dialog-main">
            {this.renderYesNoRow({
              name: "propertyGotBefore2013",
              label: "האם הדירה התקבלה לפני יום 1/8/2013?",
              isDisabled: false
            })}
            {this.renderYesNoRow({
              name: "isSellerUsedMasMutavBefore",
              label: "האם המוכר עשה שימוש בעבר בפטור מס מוטב?",
              isDisabled: false
            })}
            <div className={`deal-calc-dialog-row${isUsageCountEnabled ? "" : " is-disabled"}`}>
              <div className="deal-calc-dialog-row-copy">
                <Typography className="deal-calc-dialog-row-label">כמה פעמים השתמש המוכר בפטור מס מוטב?</Typography>
              </div>
              <div className="deal-calc-dialog-select">
                <LabeledTextField
                  disabled={!isUsageCountEnabled}
                  type="select"
                  name="sellerUsedMasMutavAmount"
                  textFieldWidth={100}
                  onChange={(e) => this.handleOnChange(e)}
                  value={this.state.sellerUsedMasMutavAmount}
                  options={[
                    { value: 1, label: 1 },
                    { value: 2, label: 2 }
                  ]}
                />
              </div>
            </div>
            {this.renderYesNoRow({
              name: "sellerSellAnotherPropertyWithPtor",
              label:
                "האם המוכר מכר דירה אחרת בפטור ממס, לרבות פטור חלקי (הוראת שעה), נתן דירה במתנה למי שאינו ילדו או בן זוגו, בארבע השנים שקדמו למכירת הדירה?",
              isDisabled: !isOtherSaleQuestionEnabled
            })}
            {this.renderYesNoRow({
              name: "isBuyetRelatedToSeller",
              label: "האם מכירת הדירה כיום בתמורה או שלא בתמורה הינה לקרוב של המוכר כדלהלן?",
              extraLabel: "(1) בן-זוג;\n(2) הורה, הורי הורה, צאצא, צאצאי בן-זוג ובני-זוגם של כל אחד מאלה;\n(3) אח או אחות ובני-זוגם;\n(4) איגוד שהוא בשליטתו;",
              isDisabled: !isRelatedBuyerQuestionEnabled
            })}
            {this.renderYesNoRow({
              name: "isSoldAsHalukatIzavon",
              label: "האם הנכס נמכר כחלק מחלוקת עזבון?",
              isDisabled: !isEstateQuestionEnabled
            })}
            <div className="deal-calc-dialog-actions">
              <Button className="deal-calc-dialog-check" variant="contained" onClick={this.isZakai}>
                בדוק זכאות
              </Button>
              {this.state.isChecked ? (
                <div
                  className={`deal-calc-dialog-result ${resultStatusClass}`}
                  ref={(element) => {
                    this.resultRef = element;
                  }}
                >
                  {this.state.isZakai ? <CheckCircleRoundedIcon /> : <WarningRoundedIcon />}
                  <Typography>{resultText}</Typography>
                </div>
              ) : null}
            </div>
          </div>
          <aside className="deal-calc-dialog-aside">
            <div className="deal-calc-dialog-illustration">
              <img alt="" src={Popup} />
            </div>
          </aside>
        </div>
      </CustomDialog>
    );
  }

  renderYesNoRow({ name, label, extraLabel, isDisabled }) {
    return (
      <div className={`deal-calc-dialog-row${isDisabled ? " is-disabled" : ""}`} key={name}>
        <div className="deal-calc-dialog-row-copy">
          <Typography className="deal-calc-dialog-row-label">{label}</Typography>
          {extraLabel
            ? extraLabel.split("\n").map((line) => (
                <Typography className="deal-calc-dialog-row-hint" key={line}>
                  {line}
                </Typography>
              ))
            : null}
        </div>
        <FormControl component="fieldset" disabled={isDisabled}>
          <RadioGroup
            row
            name={name}
            value={Boolean(this.state[name]).toString()}
            onChange={(e) => this.handleOnChange(e)}
          >
            <FormControlLabel value={"true"} control={<Radio color="primary" />} label="כן" labelPlacement="end" />
            <FormControlLabel value={"false"} control={<Radio color="primary" />} label="לא" labelPlacement="end" />
          </RadioGroup>
        </FormControl>
      </div>
    );
  }

  isZakai = () => {
    let isZakai = true;
    if (this.state.sellerUsedMasMutavAmount === 2) isZakai = false;
    else if (this.state.sellerSellAnotherPropertyWithPtor) isZakai = false;
    else if (this.state.isBuyetRelatedToSeller && !this.state.isSoldAsHalukatIzavon) isZakai = false;
    this.setState({ isZakai, isChecked: true }, () => {
      if (!this.resultRef) return;
      const dialogContent = this.resultRef.closest(".MuiDialogContent-root");
      if (dialogContent) dialogContent.scrollTop = 0;
      if (typeof this.resultRef.scrollIntoView === "function") {
        this.resultRef.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
    if (this.props.handleResults) this.props.handleResults({ target: { value: isZakai, name: "isMutavAllowed" } });
  };

  handleOnChange(e) {
    let val = e.target.value;
    if (val === "true") val = true;
    if (val === "false") val = false;
    const newState = { ...this.state, [e.target.name]: val, isChecked: false, isZakai: false };
    this.handleDependencies(e, newState);
    this.setState(newState);
  }

  handleDependencies(e, newState) {
    if (e.target.name === "isSellerUsedMasMutavBefore") {
      if (e.target.value === "false") {
        newState.sellerUsedMasMutavAmount = 1;
        newState.sellerSellAnotherPropertyWithPtor = false;
        newState.isBuyetRelatedToSeller = false;
        newState.isSoldAsHalukatIzavon = false;
      }
    } else if (e.target.name === "sellerUsedMasMutavAmount") {
      if (e.target.value === 2) {
        newState.sellerSellAnotherPropertyWithPtor = false;
        newState.isBuyetRelatedToSeller = false;
        newState.isSoldAsHalukatIzavon = false;
      }
    } else if (e.target.name === "sellerSellAnotherPropertyWithPtor") {
      if (e.target.value === "true") {
        newState.isBuyetRelatedToSeller = false;
        newState.isSoldAsHalukatIzavon = false;
      }
    } else if (e.target.name === "isBuyetRelatedToSeller") {
      if (e.target.value === "false") {
        newState.isSoldAsHalukatIzavon = false;
      }
    }
  }
}

export default IsMutavAllowedDialog;
